var React = require('react');

function Wind (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.st0{fill:none;stroke:#3B6E8F;stroke-width:8;stroke-linecap:round;stroke-miterlimit:10;}\r\n"),React.createElement("path",{"className":"st0","d":"M92,60c0-9.9,8.1-18,18-18s18,8.1,18,18s-8.1,18-18,18H29","key":1}),React.createElement("path",{"className":"st0","d":"M128,145c0,6.6,5.4,12,12,12s12-5.4,12-12c0-6.6-5.4-12-12-12H53","key":2}),React.createElement("path",{"className":"st0","d":"M143,86c0-11.6,9.4-21,21-21s21,9.4,21,21s-9.4,21-21,21H14","key":3})]);
}

Wind.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"200px","height":"200px","viewBox":"0 0 200 200","style":{"enableBackground":"new 0 0 200 200"},"xmlSpace":"preserve"};

module.exports = Wind;

Wind.default = Wind;
